var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoissaAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#F7BCB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.509 277.996C352.079 273.097 328.837 246.716 328.837 214.906C328.837 179.611 357.448 151 392.743 151C421.103 151 445.148 169.474 453.502 195.043C458.364 209.898 461.291 225.891 461.291 242.37C461.291 295.359 434.103 341.999 392.916 369.099L392.914 369.096C390.557 370.688 387.717 371.618 384.658 371.618C376.503 371.618 369.89 365.007 369.89 356.85C369.89 353.088 371.297 349.655 373.614 347.047C386.517 332.466 394.536 313.476 394.999 292.59C394.999 285.199 389.569 279.077 382.481 277.993L382.509 277.996Z",
    fill: "#010303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.989 299.521C294.989 217.495 248.389 151 190.906 151H152.945C149.056 151.001 145.172 152.528 142.271 155.56C136.629 161.456 136.777 170.86 142.672 176.501C170.279 203.209 188.421 248.342 188.421 299.521C188.421 381.548 235.023 448.043 292.505 448.043H330.466C334.355 448.042 338.239 446.515 341.141 443.483C346.783 437.587 346.635 428.183 340.739 422.541C313.132 395.834 294.99 350.701 294.99 299.521H294.989Z",
    fill: "#010303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoissaAvatar);
export default __webpack_public_path__ + "static/media/voissa-avatar.e5bb7847149a9607871af558546d8940.svg";
export { ForwardRef as ReactComponent };